export type InitialDataSlice = 'customer' | 'gateways' | 'withdrawals';

const SLICE_ROOT_FIELD: Record<InitialDataSlice, string> = {
  customer: 'customer',
  gateways: 'payment_method_groups',
  withdrawals: 'withdrawal_requests',
};

export const createInitialDataPrefetch = () => {
  let response: any = null;
  let responseVariables: Record<string, unknown> = {};
  const consumed = new Set<InitialDataSlice>();

  const variablesMatch = (required: Record<string, unknown>): boolean =>
    Object.keys(required).every(
      (key) => (responseVariables[key] ?? null) === (required[key] ?? null),
    );

  const store = (nextResponse: any, nextVariables?: Record<string, unknown>): void => {
    response = nextResponse ?? null;
    responseVariables = nextVariables ?? {};
    consumed.clear();
  };

  const take = (slice: InitialDataSlice, requiredVariables?: Record<string, unknown>): any => {
    if (!response || consumed.has(slice)) return null;
    if (response[SLICE_ROOT_FIELD[slice]] === undefined) return null;
    if (requiredVariables && !variablesMatch(requiredVariables)) return null;

    consumed.add(slice);
    return response;
  };

  return { store, take };
};

export const initialDataPrefetch = createInitialDataPrefetch();
